import React from "react";
import {InputBase} from '@material-ui/core';
import {getFontSize} from "my-styles/media/media";

export default function IconRichTextView(props) {
    return (<table className={props.className?props.className+" inputBox marginTopBottomSmall " : "inputBox marginTopBottomSmall "}>
        <tbody className="fullWidth">
        <tr className="fullWidth">
            <td>
                {props.icon}
            </td>
            <td className="fullWidth">
                <InputBase
                    multiline
                    maxRows={6}
                    placeholder={props.placeholder}
                    defaultValue={props.defaultValue}
                    disabled={props.disabled}
                    onChange={props.onChange}
                    style={{
                        fontSize: getFontSize(),
                        width: "90%",
                        height: props.height ? props.height : "10em"
                    }}
                    inputProps={{'aria-label': 'naked'}}/>
            </td>
        </tr>
        </tbody>
    </table>)
}